export class UserNotification {
  Id: number;
  UserId: string;
  TimeCreated: Date;
  Subject: string;
  Body: string;
  Active: boolean;
  IsRead: boolean;
  IsDismissed: boolean;
}
